// extracted by mini-css-extract-plugin
export default {"root":"root__2U0ew","hideContent":"hideContent__RdXAv","fadeOutAnimation":"fadeOutAnimation__AlTGk"};